import { useMemo } from 'react';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { EditType } from './EditType';
import { ProtectionIsEnabled } from '../../../lib/helpers/ProtectionIsEnabled';
import ItemIsReady from '../../../lib/helpers/ItemIsReady';
import ItemProtectionSummary from './ItemProtectionSummary';

interface props {
  item: SmartSendItemApiModel;
  edit?: (type: EditType) => void;
  section: string;
}

const ItemProtectionSummaryCheck = (props: props) => {
  const enabled = useMemo(() => ProtectionIsEnabled(props.item) && ItemIsReady(props.item), [props.item]);
  return !enabled ? null : <ItemProtectionSummary item={props.item} edit={props.edit} section={props.section} />;
};
export default ItemProtectionSummaryCheck;
